import * as React from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'
import { style } from 'typestyle'
import Icon from '../../../common/src/components/Icon'
import { Colors, Fonts } from '../../../common/src/constants'
import { TestIds } from '../../../common/src/data/testids'
import { ElemType } from './agentCalendar'

interface CalendarModalProps {
  title: string
  top: string
  onClose: () => void
}

export default class CalendarModal extends React.PureComponent<CalendarModalProps> {
  modalContainer = document.getElementById('calendar-modal')
  render() {
    const { top, children, onClose } = this.props
    const ret = (
      <ModalBoxContainer>
        <div className={modalBoxClass({ top })}>
          <ButtonWrapper>
            <CloseButton onClick={onClose} data-testid={TestIds.calendarModalCloseButton}>
              <Icon name="close" color="steel" />
            </CloseButton>
          </ButtonWrapper>
          <ModalBody>{children}</ModalBody>
        </div>
      </ModalBoxContainer>
    )

    if (this.modalContainer) {
      return ReactDOM.createPortal(ret, this.modalContainer)
    }
    return null
  }
}

const ModalBoxContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100vw',
  height: '100vh',
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 10,
  padding: '32px',
  boxSizing: 'border-box',
})

const modalBoxClass = (props: { top: string }) =>
  style({
    width: '420px',
    position: 'absolute',
    top: props.top,
    backgroundColor: 'white',
    border: `1px solid ${Colors.snow}`,
    borderRadius: '6px',
    overflow: 'hidden',
    boxShadow: '0 20px 50px 10px rgba(0, 0, 0, 0.5)',
  })

const ModalBody = styled.div({
  padding: '16px 24px',
  boxSizing: 'border-box',
  overflowX: 'hidden',
  height: '100%',
  maxHeight: '80vh',
  lineHeight: '22px',
})

const ButtonWrapper = styled.div({
  display: 'flex',
  flexDirection: 'row-reverse',
  marginBottom: '-35px',
})

const CloseButton = styled.div({
  float: 'right',
  cursor: 'pointer',
  width: '48px',
  height: '48px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const IconAndTextWrapper = styled.div({
  display: 'flex',
  color: Colors.midway,
})

export const iconBoxClass = (props: { marginTop?: string }) =>
  style({
    width: '32px',
    marginRight: '16px',
    marginTop: props.marginTop == null ? '20px' : props.marginTop,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  })

export const Img = styled.img({
  maxWidth: '100%',
  borderRadius: '6px',
})

export const ModalFirstTitle = styled.span({
  color: '#444448',
  display: 'inline',
  fontWeight: 'bold',
  fontFamily: `${Fonts.sansHeader}`,
  fontSize: '21px',
  minHeight: 'fit-content',
})

export const ModalSecondTitle = styled.span({
  color: '#444448',
  display: 'inline',
  fontFamily: `${Fonts.sansHeader}`,
  fontSize: '21px',
})

/**
 * For the date and time span of the showing or BUSY/FREE block.
 */
export const ModalDateTime = styled.div({
  marginTop: '4px',
  fontFamily: `${Fonts.sansBody}`,
  fontSize: '14px',
  color: Colors.midway,
  fontWeight: 300,
})

/**
 * For showing the information about the showing/property: unit type, number of prospect attendees, property address, unit type
 */
export const PropertyInfo = styled.div({
  marginTop: '24px',
  color: '#343438',
  fontSize: '16px',
  lineHeight: '26px',
  fontFamily: `${Fonts.sansBody}`,
})

/**
 * e.g. In-person / Virtual
 */
export const ShowingTourType = styled.span({
  display: 'inline',
  fontFamily: `${Fonts.sansBody}`,
  fontWeight: 'bold',
})

export const PropertyAddress = styled.div({
  fontSize: '12px',
  color: '#a4a3a8',
  lineHeight: '18px',
})

/**
 * e.g. 2 bedroom · 1 accepted prospect
 */
export const UnitInfo = styled.div({
  color: '#4e4e52',
})

/**
 * The section in showing modal that holds information about attending prospects.
 * Similarly, the section in free/busy modal that holds information about the different
 * free/busy time periods within that block.
 */
export const ModalDetails = styled.div({
  backgroundColor: Colors.snow,
  width: '385px',
  fontSize: '14px',
  lineHeight: '22px',
  letterSpacing: 0,
  display: 'block',
  marginTop: '12px',
  marginLeft: '-25px',
  padding: '12px 12px 13px 25px',
})

export const SmallNote = styled.div({
  color: '#bfbec2',
  fontSize: '12px',
  lineHeight: '18px',
})

export const freeBusyIconClass = (props: { elemType: ElemType }) =>
  style({
    backgroundColor: props.elemType === ElemType.BLOCKED ? Colors.coral : Colors.mint,
    backgroundImage: 'url(https://dynasty-images.s3-us-west-1.amazonaws.com/stripes-tile.png)',
    width: '32px',
    height: '32px',
    objectFit: 'contain',
    borderRadius: '6px',
  })

/**
 * e.g. "Declined in Outlook" sign indicating agent's confirmation status for showing.
 */
export const declinedClass = (props: { isSource?: boolean }) =>
  style({
    color: props.isSource ? '#9a9a9f' : Colors.coral,
  })
